module.exports = __webpack_public_path__ + "static/media/HR_iPad_Vertical.6b4efc34.png";